import React, { Component } from 'react';
import './HotAuthTigger.css';
import Button from '../components/Button';

class HotAuthTigger extends Component {
  render() {
    return (
      <Button label="Acessar a Internet" name='inicio' onClick={this.props.onClick}/>
    );
  }
}

export default HotAuthTigger;